module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/40fdAyC1BVxWxt55ZJxhNK-ea85b9e4188fe76d9e52b001a72c406a.jpg";